import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { Variants } from 'components/Toolkit/InfoTitle/InfoTitle';

const SubtitleItem = styled.li<{
  variant: Variants;
}>`
  ${({ theme, variant }) =>
    variant === 'SMALL' || variant === 'XS'
      ? theme.fontSize.B12
      : theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  list-style: none;
  display: flex;
  align-items: center;

  &:after {
    width: ${({ theme }) => theme.spacing.S4};
    height: ${({ theme }) => theme.spacing.S4};
    background: ${({ theme }) => theme.colors.GREY};
    margin-left: ${({ theme }) => theme.spacing.S8};
    margin-right: ${({ theme }) => theme.spacing.S8};
    content: '';
    border-radius: 50%;
  }

  &:last-child {
    &:after {
      width: ${({ theme }) => theme.spacing.S4};
      content: none;
      height: 100%;
    }
  }

  ${media.large} {
    ${({ theme, variant }) => variant === 'XS' && theme.fontSize.M14};
  }
`;

export { SubtitleItem };
